import { DatePicker, Divider, Select, Radio, Modal, message, Button } from "antd";
import React, { useState, useEffect, useRef } from "react";
import FileUpload from "../../ant-components/file-upload";
import { Man, Woman } from "../../constant/imgages";
import dayjs from "dayjs";
import { putRequest, uploadFile } from "../../service";
import { getChangedFields } from "../../utils/getChangedFields";

const GenInfo = (props) => {
  const { open, onRequestClose, employee } = props;
  const [formData, setFormData] = useState({});
  const originalFormRef = useRef({});
  const originalPasswordRef = useRef("");

  useEffect(() => {
    if (employee) {
      const initialData = {
        gender: employee.gender,
        firstName: employee.firstName,
        lastName: employee.lastName,
        fatherName: employee.fatherName,
        emailAddress: employee.emailAddress,
        password: "",
        bloodGroup: employee.bloodGroup,
        dob: employee.dob,
        religion: employee.religion,
        qualification: employee.qualification,
        maritalStatus: employee.maritalStatus,
        contact_number: employee.contact_number,
        image: employee.image
      };
      setFormData(initialData);
      originalFormRef.current = { ...initialData };
      originalPasswordRef.current = employee.password || "";
    }
  }, [employee]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSelectChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDateChange = (date) => {
    setFormData(prev => ({
      ...prev,
      dob: date ? date.format('YYYY-MM-DD') : null
    }));
  };

  const handleFileChange = (url) => {
    setFormData(prev => ({
      ...prev,
      image: url
    }));
  };

  const handleSubmit = async () => {
    try {
      const payload = getChangedFields(originalFormRef.current, formData, {
        exclude: ["password"],
      });

      if (formData.password && formData.password !== originalPasswordRef.current) {
        payload.password = formData.password;
      }

      if (Object.keys(payload).length === 0) {
        message.info("No changes to update");
        return;
      }

      const response = await putRequest(`/api/employees?employeeId=${employee._id}`, payload);
      if (response.message === 'Employee updated successfully (some related data could not be loaded)') {
        message.success('Employee updated successfully')
        onRequestClose();
      }
      else {
        message.error(response.message || "Employee not updated")
      }
    } catch (error) {
      console.error('Error updating employee:', error);
    }
  };
  
  const getGenderImage = () => {
    if (formData.gender === 'male') return Man;
    if (formData.gender === 'female') return Woman;
    return null;
  };

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" },
  ];

  const bloodGroupOptions = [
    { value: "A+", label: "A+" },
    { value: "A-", label: "A-" },
    { value: "B+", label: "B+" },
    { value: "B-", label: "B-" },
    { value: "O+", label: "O+" },
    { value: "O-", label: "O-" },
    { value: "AB+", label: "AB+" },
    { value: "AB-", label: "AB-" },
  ];

  const religionOptions = [
    { value: "Muslim", label: "Muslim" },
    { value: "Hindu", label: "Hindu" },
    { value: "Sikh", label: "Sikh" },
    { value: "Christian", label: "Christian" },
    { value: "Other", label: "Other" },
  ];

  const qualificationOptions = [
    { value: "Matric", label: "Matric" },
    { value: "Inter", label: "Inter" },
    { value: "Bachelor", label: "Bachelor" },
    { value: "Master", label: "Master" },
    { value: "PHD", label: "PHD" },
  ];

  const maritalStatusOptions = [
    { value: "Single", label: "Single" },
    { value: "Married", label: "Married" },
    { value: "Divorced", label: "Divorced" },
    { value: "Widow", label: "Widow" },
  ];

  return (
    <Modal
      title="General Information"
      open={open}
      onCancel={onRequestClose}
      footer={null}
      width={800}
    >
      <div className="flex items-start justify-between bg-white px-4 h-[60vh] overflow-auto">
        <div className="bg-form-bg w-full rounded-md px-4 flex flex-col gap-6 py-8">
          {formData.gender !== 'other' && (
            <>
            <div className="mx-auto border-[1.5px] border-active-color h-20 w-20 rounded-full">
              {formData.image ? (
                <img
                  src={formData.image}
                  alt="User"
                  className="object-cover h-full w-full rounded-full"
                />
              ) : (
                <img
                  src={getGenderImage()}
                  alt="Gender"
                  className="object-cover h-full w-full rounded-full"
                />
              )}
            </div>
             <Divider />
             </>
          )}
         
          <div className="flex flex-col gap-2 text-md">
            <label>Gender</label>
            <Radio.Group 
              value={formData.gender}
              onChange={(e) => handleSelectChange('gender', e.target.value)}
            >
              {genderOptions.map((option) => (
                <Radio key={option.value} value={option.value}>
                  {option.label}
                </Radio>
              ))}
            </Radio.Group>
          </div>
          <FileUpload onChange={handleFileChange} file={formData.image} />
          <div className="grid grid-cols-12 gap-5">
            <div className="col-span-6 flex flex-col gap-6">
              <div className="flex flex-col gap-1">
                <label htmlFor="fname" className="text-md">
                  First Name
                  <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
                </label>
                <input
                  type="text"
                  className="border px-2 py-1 rounded-md border-secondary text-md outline-none bg-white"
                  placeholder="First Name"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label htmlFor="fname" className="text-md">
                  Father Name
                </label>
                <input
                  type="text"
                  className="border px-2 py-1 rounded-md border-secondary text-md outline-none bg-white"
                  placeholder="Father Name"
                  name="fatherName"
                  value={formData.fatherName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label htmlFor="passweord" className="text-md">
                  Password
                </label>
                <input
                  type="password"
                  className="border px-2 py-1 rounded-md border-secondary text-md outline-none bg-white"
                  placeholder=""
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  autoComplete="new-password"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label htmlFor="fname" className="text-md">
                  Blood Group
                </label>
                <Select
                  placeholder="Select One"
                  options={bloodGroupOptions}
                  value={formData.bloodGroup}
                  className="w-full"
                  onChange={(value) => handleSelectChange('bloodGroup', value)}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label htmlFor="dob" className="text-md">
                  DOB
                </label>
                <DatePicker
                  placeholder="YYYY/MM/DD"
                  className="w-full"
                  value={formData.dob ? dayjs(formData.dob) : null}
                  onChange={handleDateChange}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label htmlFor="fname" className="text-md">
                  Religion
                </label>
                <Select
                  placeholder="Select One"
                  options={religionOptions}
                  value={formData.religion}
                  className="w-full"
                  onChange={(value) => handleSelectChange('religion', value)}
                />
              </div>
              
            </div>
            <div className="col-span-6 flex flex-col gap-6">
            <div className="flex flex-col gap-1">
                <label htmlFor="lname" className="text-md">
                  Last Name{" "}
                  <span className="text-red-500 relative -top-0.5 ml-0.5">*</span>
                </label>
                <input
                  type="text"
                  className="border px-2 py-1 rounded-md border-secondary text-md outline-none bg-white"
                  placeholder="Last Name"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label htmlFor="email" className="text-md">
                  Work Email
                </label>
                <input
                  type="email"
                  className="border px-2 py-1 rounded-md border-secondary text-md outline-none bg-white"
                  placeholder="Work Email"
                  name="emailAddress"
                  value={formData.emailAddress}
                  onChange={handleInputChange}
                />
              </div>
             
              <div className="flex flex-col gap-1">
                <label htmlFor="qualification" className="text-md">
                  Qualification
                </label>
                <Select
                  className="w-full"
                  placeholder="Select One"
                  name="qualification"
                  value={formData.qualification}
                  options={qualificationOptions}
                  onChange={(value) => handleSelectChange('qualification', value)}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label htmlFor="maritalStatus" className="text-md">
                  Marital Status
                </label>
                <Select
                  className="w-full"
                  placeholder="Select One"
                  name="maritalStatus"
                  value={formData.maritalStatus}
                  options={maritalStatusOptions}
                  onChange={(value) => handleSelectChange('maritalStatus', value)}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label htmlFor="fname" className="text-md">
                  Contact Number
                </label>
                <input
                  type="text"
                  className="border px-2 py-1 rounded-md border-secondary text-md outline-none bg-white"
                  placeholder="Contact Number"
                  value={formData.contact_number}
                  name="contact_number"
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end gap-3 my-2">
        <Button onClick={onRequestClose} >Cancel</Button>
        <Button
          onClick={handleSubmit}
          type="primary"
          className="bg-primary text-white"
        >
          Update General Information
        </Button>
      </div>
    </Modal>
  );
};

export default GenInfo;
